import { useRef, useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useScrollAnimation } from "@/hooks/useScrollAnimation";

const photos = [
  {
    src: "https://readdy.ai/api/search-image?query=Ikei%20Island%20Okinawa%20Japan%20turquoise%20sea%20emerald%20water%20tropical%20beach%20white%20sand%20palm%20trees%20sunny%20day%20peaceful%20serene%20coastal%20landscape%20with%20lush%20green%20vegetation%20and%20clear%20blue%20sky%20reflecting%20on%20calm%20ocean%20surface&width=600&height=420&seq=gallery1&orientation=landscape",
    captionJa: "伊計島の碧い海", subJa: "息をのむほど透き通った珊瑚礁の海",
    captionEn: "Azure Sea of Ikei Island", subEn: "Crystal-clear coral reef waters",
    captionIt: "Il Mare Azzurro dell'Isola di Ikei", subIt: "Acque cristalline della barriera corallina",
    captionFr: "La Mer Azurée de l'Île d'Ikei", subFr: "Eaux cristallines du récif corallien",
    captionDe: "Das Azurblaue Meer der Insel Ikei", subDe: "Kristallklare Korallenriffgew\u00e4sser",
    captionEs: "El Mar Azul de la Isla Ikei", subEs: "Aguas cristalinas del arrecife de coral",
    captionRu: "Лазурное море острова Икэй", subRu: "Кристально чистые воды кораллового рифа",
    captionZh: "伊计岛的碧蓝海洋", subZh: "令人屏息的清澈珊瑚礁海域",
    captionKo: "이케이지마의 푸른 바다", subKo: "숨이 멎을 듯 맑은 산호초 바다",
    captionPt: "Mar Azul da Ilha Ikei", subPt: "Águas cristalinas do recife de coral",
    captionAr: "بحر جزيرة إيكي الأزرق", subAr: " المياه المرجانية الصافية كالكريستال",
    captionHi: "इकेई द्वीप का नीला समुद्र", subHi: "क्रिस्टल-स्पष्ट प्रवाल भित्ति जल",
    captionTh: "ทะเลสีฟ้าของเกาะอิเคอิ", subTh: "น้ำแนวปะการังใสราวคริสตัล",
    captionVi: "Biển xanh của đảo Ikei", subVi: "Vùng nước san hô trong vắt như pha lê",
    captionId: "Laut Biru Pulau Ikei", subId: "Air terumbu karang yang jernih seperti kristal",
    captionTl: "Asul na Dagat ng Pulo ng Ikei", subTl: "Malinaw na tubig ng coral reef na parang kristal",
    captionNe: "इकेई टापुको नीलो समुद्र", subNe: "क्रिस्टलजस्तो स्वच्छ प्रवाल भित्ति जल",
    captionZhTW: "伊計島的碧藍海洋", subZhTW: "令人屏息的清澈珊瑚礁海域",
  },
  {
    src: "https://readdy.ai/api/search-image?query=Okinawa%20Japan%20tropical%20sunset%20orange%20golden%20sky%20over%20calm%20ocean%20sea%20warm%20colors%20reflecting%20on%20water%20surface%20peaceful%20evening%20atmosphere%20beautiful%20horizon&width=600&height=420&seq=gallery2&orientation=landscape",
    captionJa: "島の夕暮れ", subJa: "橙色に染まる水平線と静かな時間",
    captionEn: "Island Sunset", subEn: "A horizon dyed in orange, a quiet moment",
    captionIt: "Tramonto sull'Isola", subIt: "Un orizzonte tinto d'arancio, un momento di quiete",
    captionFr: "Coucher de Soleil sur l'Île", subFr: "Un horizon teinté d'orange, un moment de quiétude",
    captionDe: "Sonnenuntergang auf der Insel", subDe: "Ein orangegef\u00e4rbter Horizont, ein stiller Moment",
    captionEs: "Atardecer en la Isla", subEs: "Un horizonte te\u00f1ido de naranja, un momento tranquilo",
    captionRu: "Закат на острове", subRu: "Горизонт, окрашенный в оранжевый, тихий момент",
    captionZh: "岛屿的黄昏", subZh: "染成橙色的地平线与宁静的时光",
    captionKo: "섬의 황혼", subKo: "주황빛으로 물드는 수평선과 고요한 시간",
    captionPt: "Pôr do Sol na Ilha", subPt: "Um horizonte tingido de laranja, um momento tranquilo",
    captionAr: "غروب الجزيرة", subAr: "أفق مصبوغ بالبرتقالي، لحظة هادئة",
    captionHi: "द्वीप का सूर्यास्त", subHi: "नारंगी रंग में रंगा क्षितिज, एक शांत पल",
    captionTh: "พระอาทิตย์ตกบนเกาะ", subTh: "ขอบฟ้าที่ย้อมด้วยสีส้ม ช่วงเวลาอันเงียบสงบ",
    captionVi: "Hoàng hôn trên đảo", subVi: "Đường chân trời nhuộm màu cam, một khoảnh khắc yên bình",
    captionId: "Matahari Terbenam di Pulau", subId: "Cakrawala yang diwarnai oranye, momen yang tenang",
    captionTl: "Paglubog ng Araw sa Pulo", subTl: "Abot-tanaw na may kulay kahel, isang tahimik na sandali",
    captionNe: "टापुको सूर्यास्त", subNe: "सुन्तला रंगमा रंगिएको क्षितिज, एउटा शान्त क्षण",
    captionZhTW: "島嶼的黃昏", subZhTW: "染成橙色的地平線與寧靜的時光",
  },
  {
    src: "https://readdy.ai/api/search-image?query=Okinawa%20Japan%20traditional%20red%20tile%20roof%20ryukyu%20house%20surrounded%20by%20tropical%20plants%20hibiscus%20flowers%20stone%20wall%20old%20village%20quiet%20rural%20scenery%20warm%20sunlight&width=600&height=420&seq=gallery3&orientation=landscape",
    captionJa: "琉球の古民家", subJa: "赤瓦と緑が織りなす島の原風景",
    captionEn: "Ryukyu Old House", subEn: "Red tiles and greenery weave the island's original scenery",
    captionIt: "Casa Tradizionale Ryukyu", subIt: "Tegole rosse e verde intrecciano il paesaggio originale dell'isola",
    captionFr: "Maison Traditionnelle Ryukyu", subFr: "Tuiles rouges et verdure tissent le paysage originel de l'île",
    captionDe: "Traditionelles Ryukyu-Haus", subDe: "Rote Ziegel und Gr\u00fcn weben die urspr\u00fcngliche Landschaft der Insel",
    captionEs: "Casa Tradicional Ryukyu", subEs: "Tejas rojas y verdor tejen el paisaje original de la isla",
    captionRu: "Традиционный дом Рюкю", subRu: "Красная черепица и зелень ткут первозданный пейзаж острова",
    captionZh: "琉球古民居", subZh: "红瓦与绿意交织而成的岛屿原始风景",
    captionKo: "류큐의 고민가", subKo: "붉은 기와와 초록이 어우러진 섬の 원풍경",
    captionPt: "Casa Tradicional Ryukyu", subPt: "Telhas vermelhas e vegetação tecem a paisagem original da ilha",
    captionAr: "منزل ريوكيو التقليدي", subAr: "القرميد الأحمر والخضرة تنسج المشهد الأصلي للجزيرة",
    captionHi: "रयूक्यू का पारंपरिक घर", subHi: "लाल टाइलें और हरियाली द्वीप के मूल दृश्य को बुनती हैं",
    captionTh: "บ้านเก่าริวกิว", subTh: "กระเบื้องแดงและสีเขียวทอเป็นทิวทัศน์ดั้งเดิมของเกาะ",
    captionVi: "Nhà cổ Ryukyu", subVi: "Ngói đỏ và cây xanh dệt nên phong cảnh nguyên sơ của đảo",
    captionId: "Rumah Tua Ryukyu", subId: "Genteng merah dan hijau menenun pemandangan asli pulau",
    captionTl: "Lumang Bahay ng Ryukyu", subTl: "Pulang bubong at berde na humahabi sa orihinal na tanawin ng pulo",
    captionNe: "रयूक्यूको पुरानो घर", subNe: "रातो टाइल र हरियालीले बुनिएको टापुको मूल दृश्य",
    captionZhTW: "琉球古民居", subZhTW: "紅瓦與綠意交織而成的島嶼原始風景",
  },
  {
    src: "https://readdy.ai/api/search-image?query=Okinawa%20Japan%20tropical%20beach%20path%20narrow%20road%20lined%20with%20tropical%20trees%20leading%20to%20ocean%20view%20bright%20sunlight%20dappled%20shade%20peaceful%20walk%20nature%20scenery&width=600&height=420&seq=gallery4&orientation=landscape",
    captionJa: "海へ続く小道", subJa: "木漏れ日の中、海へと誘われる道",
    captionEn: "Path to the Sea", subEn: "A dappled path leading to the ocean",
    captionIt: "Sentiero verso il Mare", subIt: "Un sentiero ombreggiato che conduce all'oceano",
    captionFr: "Chemin vers la Mer", subFr: "Un chemin ombragé menant à l'océan",
    captionDe: "Weg zum Meer", subDe: "Ein schattiger Pfad, der zum Ozean f\u00fchrt",
    captionEs: "Camino al Mar", subEs: "Un sendero sombreado que lleva al oc\u00e9ano",
    captionRu: "Тропинка к морю", subRu: "Тенистая тропинка, ведущая к океану",
    captionZh: "通往大海的小路", subZh: "在阳光斑驳中，通向大海的小径",
    captionKo: "바다로 이어지는 오솔길", subKo: "나뭇잎 사이로 비치는 햇살 속, 바다로 이끄는 길",
    captionPt: "Caminho para o Mar", subPt: "Uma trilha sombreada que leva ao oceano",
    captionAr: "طريق إلى البحر", subAr: "ممر مظلل يؤدي إلى المحيط",
    captionHi: "समुद्र की ओर रास्ता", subHi: "एक छायादार रास्ता जो महासागर की ओर ले जाता है",
    captionTh: "เส้นทางสู่ทะเล", subTh: "ทางเดินร่มรื่นที่นำไปสู่มหาสมุทร",
    captionVi: "Con đường ra biển", subVi: "Lối đi bóng mát dẫn đến đại dương",
    captionId: "Jalan Menuju Laut", subId: "Jalan teduh yang menuju ke samudra",
    captionTl: "Landas Patungo sa Dagat", subTl: "Isang maanino na landas na patungo sa karagatan",
    captionNe: "समुद्रतर्फको बाटो", subNe: "महासागरतर्फ जाने छायादार बाटो",
    captionZhTW: "通往大海的小路", subZhTW: "在陽光斑駁中，通向大海的小徑",
  },
  {
    src: "https://readdy.ai/api/search-image?query=Okinawa%20Japan%20coral%20reef%20shallow%20water%20clear%20turquoise%20tropical%20fish%20colorful%20marine%20life%20view%20from%20above%20beautiful%20natural%20scenery%20sunny%20day&width=600&height=420&seq=gallery5&orientation=landscape",
    captionJa: "珊瑚礁の海中", subJa: "色とりどりの命が宿る珊瑚の世界",
    captionEn: "Coral Reef World", subEn: "A world of colorful life in the coral",
    captionIt: "Il Mondo della Barriera Corallina", subIt: "Un mondo di vita colorata nel corallo",
    captionFr: "Le Monde du Récif Corallien", subFr: "Un monde de vie colorée dans le corail",
    captionDe: "Die Welt des Korallenriffs", subDe: "Eine Welt bunten Lebens im Korall",
    captionEs: "El Mundo del Arrecife de Coral", subEs: "Un mundo de vida colorida en el coral",
    captionRu: "Мир кораллового рифа", subRu: "Мир красочной жизни в коралловых зарослях",
    captionZh: "珊瑚礁的海底世界", subZh: "孕育着五彩缤纷生命的珊瑚世界",
    captionKo: "산호초의 바닷속", subKo: "형형색색의 생명이 깃든 산호의 세계",
    captionPt: "Mundo do Recife de Coral", subPt: "Um mundo de vida colorida no coral",
    captionAr: "عالم الشعاب المرجانية", subAr: "عالم من الحياة الملونة في المرجان",
    captionHi: "प्रवाल भित्ति की दुनिया", subHi: "प्रवाल में रंगीन जीवन की एक दुनिया",
    captionTh: "โลกแนวปะการัง", subTh: "โลกแห่งชีวิตสีสันในปะการัง",
    captionVi: "Thế giới rạn san hô", subVi: "Thế giới sự sống đầy màu sắc trong san hô",
    captionId: "Dunia Terumbu Karang", subId: "Dunia kehidupan penuh warna di terumbu karang",
    captionTl: "Mundo ng Coral Reef", subTl: "Isang mundo ng makulay na buhay sa coral",
    captionNe: "प्रवाल भित्तिको संसार", subNe: "प्रवालमा रंगीन जीवनको एउटा संसार",
    captionZhTW: "珊瑚礁的海底世界", subZhTW: "孕育著五彩繽紛生命的珊瑚世界",
  },
  {
    src: "https://readdy.ai/api/search-image?query=Okinawa%20Japan%20tropical%20island%20starry%20night%20sky%20milky%20way%20stars%20over%20calm%20ocean%20sea%20silhouette%20of%20palm%20trees%20dark%20peaceful%20atmosphere%20spiritual%20mystical&width=600&height=420&seq=gallery6&orientation=landscape",
    captionJa: "満天の星空", subJa: "光害のない島だから見える、無数の星",
    captionEn: "Starry Night Sky", subEn: "Countless stars visible on this light-free island",
    captionIt: "Cielo Stellato", subIt: "Innumerevoli stelle visibili su quest'isola senza inquinamento luminoso",
    captionFr: "Ciel Étoilé", subFr: "D'innombrables étoiles visibles sur cette île sans pollution lumineuse",
    captionDe: "Sternenhimmel", subDe: "Unz\u00e4hlige Sterne sichtbar auf dieser lichtfreien Insel",
    captionEs: "Cielo Estrellado", subEs: "Innumerables estrellas visibles en esta isla sin contaminaci\u00f3n lum\u00ednica",
    captionRu: "Звёздное ночное небо", subRu: "Бесчисленные звёзды, видимые на этом острове без светового загрязнения",
    captionZh: "满天繁星", subZh: "没有光污染的岛屿才能看到的无数星辰",
    captionKo: "별이 가득한 밤하늘", subKo: "빛 공해 없는 섬이기에 볼 수 있는 무수한 별들",
    captionPt: "Céu Estrelado", subPt: "Inúmeras estrelas visíveis nesta ilha sem poluição luminosa",
    captionAr: "سماء مرصعة بالنجوم", subAr: "نجوم لا تُحصى مرئية في هذه الجزيرة الخالية من التلوث الضوئي",
    captionHi: "तारों भरा रात का आकाश", subHi: "इस प्रकाश-मुक्त द्वीप पर दिखने वाले अनगिनत तारे",
    captionTh: "ท้องฟ้าเต็มไปด้วยดาว", subTh: "ดาวนับไม่ถ้วนที่มองเห็นได้บนเกาะที่ปราศจากมลภาวะแสง",
    captionVi: "Bầu trời đầy sao", subVi: "Vô số ngôi sao hiện ra trên hòn đảo không ô nhiễm ánh sáng",
    captionId: "Langit Berbintang", subId: "Bintang tak terhitung yang terlihat di pulau bebas polusi cahaya",
    captionTl: "Kalangitan Puno ng Bituin", subTl: "Walang bilang na mga bituin na nakikita sa pulong walang polusyon ng liwanag",
    captionNe: "ताराहरूले भरिएको रातको आकाश", subNe: "प्रकाश प्रदूषण नभएको यस टापुमा देखिने अनगिनती ताराहरू",
    captionZhTW: "滿天繁星", subZhTW: "沒有光污染的島嶼才能看到的無數星辰",
  },
  {
    src: "https://readdy.ai/api/search-image?query=Okinawa%20Japan%20tropical%20white%20sand%20beach%20with%20crystal%20clear%20shallow%20water%20gentle%20waves%20lapping%20shore%20coconut%20palm%20trees%20blue%20sky%20peaceful%20paradise%20island%20scenery&width=600&height=420&seq=gallery7&orientation=landscape",
    captionJa: "白砂のビーチ", subJa: "手つかずの自然が残る静かな浜辺",
    captionEn: "White Sand Beach", subEn: "A quiet shore where untouched nature remains",
    captionIt: "Spiaggia di Sabbia Bianca", subIt: "Una riva silenziosa dove la natura incontaminata rimane",
    captionFr: "Plage de Sable Blanc", subFr: "Un rivage paisible où la nature intacte demeure",
    captionDe: "Wei\u00dfer Sandstrand", subDe: "Ein stilles Ufer, wo unber\u00fchrte Natur verbleibt",
    captionEs: "Playa de Arena Blanca", subEs: "Una orilla tranquila donde la naturaleza intacta permanece",
    captionRu: "Белопесчаный пляж", subRu: "Тихий берег, где сохранилась нетронутая природа",
    captionZh: "白沙海滩", subZh: "保留着未经开发自然风貌的宁静海岸",
    captionKo: "하얀 모래 해변", subKo: "손길 닿지 않은 자연이 남아있는 조용한 해변",
    captionPt: "Praia de Areia Branca", subPt: "Uma orla tranquila onde a natureza intocada permanece",
    captionAr: "شاطئ الرمال البيضاء", subAr: "شاطئ هادئ حيث تبقى الطبيعة بكراً",
    captionHi: "सफेद रेत का समुद्र तट", subHi: "एक शांत किनारा जहां अछूती प्रकृति बनी हुई है",
    captionTh: "หาดทรายขาว", subTh: "ชายฝั่งอันเงียบสงบที่ธรรมชาติยังคงบริสุทธิ์",
    captionVi: "Bãi cát trắng", subVi: "Bờ biển yên tĩnh nơi thiên nhiên còn nguyên vẹn",
    captionId: "Pantai Pasir Putih", subId: "Pantai tenang di mana alam masih terjaga",
    captionTl: "Puting Buhangin na Dalampasigan", subTl: "Isang tahimik na baybayin kung saan nananatiling buo ang kalikasan",
    captionNe: "सेतो बालुवाको समुद्र तट", subNe: "अछुतो प्रकृति बाँकी रहेको शान्त किनारा",
    captionZhTW: "白沙海灘", subZhTW: "保留著未經開發自然風貌の寧靜海岸",
  },
  {
    src: "https://readdy.ai/api/search-image?query=Okinawa%20Japan%20tropical%20mangrove%20forest%20river%20estuary%20green%20lush%20vegetation%20calm%20water%20reflection%20peaceful%20nature%20scenery%20morning%20light%20mist&width=600&height=420&seq=gallery8&orientation=landscape",
    captionJa: "マングローブの森", subJa: "生命の息吹が感じられる緑の迷宮",
    captionEn: "Mangrove Forest", subEn: "A green labyrinth full of life",
    captionIt: "Foresta di Mangrovie", subIt: "Un labirinto verde pieno di vita",
    captionFr: "Forêt de Mangroves", subFr: "Un labyrinthe vert plein de vie",
    captionDe: "Mangrovenwald", subDe: "Ein gr\u00fcnes Labyrinth voller Leben",
    captionEs: "Bosque de Manglares", subEs: "Un laberinto verde lleno de vida",
    captionRu: "Мангровый лес", subRu: "Зелёный лабиринт, полный жизни",
    captionZh: "红树林", subZh: "充满生命气息的绿色迷宫",
    captionKo: "맹그로브 숲", subKo: "생명의 숨결이 느껴지는 초록 미로",
    captionPt: "Floresta de Manguezal", subPt: "Um labirinto verde cheio de vida",
    captionAr: "غابة المانغروف", subAr: "متاهة خضراء مليئة بالحياة",
    captionHi: "मैंग्रोव वन", subHi: "जीवन से भरी एक हरी भूलभुलैया",
    captionTh: "ป่าโกงกาง", subTh: "เขาวงกตสีเขียวที่เต็มไปด้วยชีวิต",
    captionVi: "Rừng ngập mặn", subVi: "Mê cung xanh tràn đầy sức sống",
    captionId: "Hutan Mangrove", subId: "Labirin hijau yang penuh kehidupan",
    captionTl: "Kagubatan ng Mangrove", subTl: "Isang berdeng labirinto na puno ng buhay",
    captionNe: "म्यान्ग्रोभ वन", subNe: "जीवनले भरिएको हरियो भूलभुलैया",
    captionZhTW: "紅樹林", subZhTW: "充满生命氣息的綠色迷宮",
  },
  {
    src: "https://readdy.ai/api/search-image?query=Okinawa%20Japan%20fishing%20village%20small%20harbor%20traditional%20wooden%20boats%20calm%20sea%20morning%20light%20peaceful%20coastal%20village%20scenery%20warm%20golden%20hour%20atmosphere&width=600&height=420&seq=gallery9&orientation=landscape",
    captionJa: "漁師の港", subJa: "夜明けとともに動き出す島の朝",
    captionEn: "Fisherman's Harbor", subEn: "The island morning that stirs at dawn",
    captionIt: "Porto dei Pescatori", subIt: "Il mattino dell'isola che si anima all'alba",
    captionFr: "Port des Pêcheurs", subFr: "Le matin de l'île qui s'éveille à l'aube",
    captionDe: "Fischerhafen", subDe: "Der Inselmorgen, der bei Tagesanbruch erwacht",
    captionEs: "Puerto de Pescadores", subEs: "La ma\u00f1ana de la isla que despierta al amanecer",
    captionRu: "Рыбацкая гавань", subRu: "Утро острова, пробуждающееся на рассвете",
    captionZh: "渔港", subZh: "随着黎明而苏醒的岛屿清晨",
    captionKo: "어부의 항구", subKo: "새벽과 함께 움직이기 시작하는 섬의 아침",
    captionPt: "Porto dos Pescadores", subPt: "A manhã da ilha que desperta ao amanhecer",
    captionAr: "ميناء الصيادين", subAr: "صباح الجزيرة الذي يتحرك مع الفجر",
    captionHi: "मछुआरे का बंदरगाह", subHi: "भोर में जागता द्वीप की सुबह",
    captionTh: "ท่าเรือชาวประมง", subTh: "เช้าของเกาะที่ตื่นขึ้นพร้อมรุ่งอรุณ",
    captionVi: "Cảng cá", subVi: "Buổi sáng của đảo thức dậy cùng bình minh",
    captionId: "Pelabuhan Nelayan", subId: "Pagi pulau yang bergerak bersama fajar",
    captionTl: "Daungan ng Mangingisda", subTl: "Umaga ng pulo na gumagalaw kasabay ng bukang-liwayway",
    captionNe: "माछामार्ने बन्दरगाह", subNe: "भोरसँगै जागृत हुने टापुको बिहान",
    captionZhTW: "漁港", subZhTW: "隨著黎明而甦醒的島嶼清晨",
  },
  {
    src: "https://readdy.ai/api/search-image?query=Okinawa%20Japan%20tropical%20hibiscus%20flowers%20red%20orange%20blooming%20lush%20green%20leaves%20garden%20warm%20sunlight%20close%20up%20beautiful%20floral%20scenery%20island%20nature&width=600&height=420&seq=gallery10&orientation=landscape",
    captionJa: "島の花々", subJa: "南国の陽光に咲き誇るハイビスカス",
    captionEn: "Island Flowers", subEn: "Hibiscus blooming in the tropical sun",
    captionIt: "Fiori dell'Isola", subIt: "Ibisco in fiore sotto il sole tropicale",
    captionFr: "Fleurs de l'Île", subFr: "Hibiscus en fleurs sous le soleil tropical",
    captionDe: "Inselblumen", subDe: "Hibiskus in voller Bl\u00fcte unter der tropischen Sonne",
    captionEs: "Flores de la Isla", subEs: "Hibisco en flor bajo el sol tropical",
    captionRu: "Цветы острова", subRu: "Гибискус, цветущий под тропическим солнцем",
    captionZh: "岛屿的花朵", subZh: "在南国阳光下盛开的木槿花",
    captionKo: "섬의 꽃들", subKo: "남국의 햇살 아래 활짝 피는 히비스커스",
    captionPt: "Flores da Ilha", subPt: "Hibisco florescendo sob o sol tropical",
    captionAr: "زهور الجزيرة", subAr: "الكركديه يتفتح تحت الشمس الاستوائية",
    captionHi: "द्वीप के फूल", subHi: "उष्णकटिबंधीय सूरज में खिलता गुड़हल",
    captionTh: "ดอกไม้บนเกาะ", subTh: "ชบาบานสะพรั่งใต้แสงอาทิตย์เขตร้อน",
    captionVi: "Hoa trên đảo", subVi: "Hoa dâm bụt nở rộ dưới ánh mặt trời nhiệt đới",
    captionId: "Bunga-bunga Pulau", subId: "Kembang sepatu mekar di bawah sinar matahari tropis",
    captionTl: "Mga Bulaklak ng Pulo", subTl: "Gumamela na namumukadkad sa ilalim ng tropikal na araw",
    captionNe: "टापुका फूलहरू", subNe: "उष्णकटिबंधीय सूर्यमुनि फुलेको हिबिस्कस",
    captionZhTW: "島嶼的花朵", subZhTW: "在南國陽光下盛開的木槿花",
  },
];

const CARD_WIDTH = 300;
const CARD_HEIGHT = 220;
const GAP = 12;

export default function GallerySection() {
  const { t, i18n } = useTranslation();
  const { ref: headerRef, isVisible: headerVisible } = useScrollAnimation();
  const scrollRef = useRef<HTMLDivElement>(null);
  const [activeIndex, setActiveIndex] = useState(0);
  const [isDragging, setIsDragging] = useState(false);
  const [startX, setStartX] = useState(0);
  const [scrollLeftStart, setScrollLeftStart] = useState(0);

  const lang = i18n.language;

  const getCaption = (photo: typeof photos[0]) => {
    if (lang === "zh-TW") return photo.captionZhTW;
    if (lang === "ne") return photo.captionNe;
    if (lang === "tl") return photo.captionTl;
    if (lang === "id") return photo.captionId;
    if (lang === "vi") return photo.captionVi;
    if (lang === "th") return photo.captionTh;
    if (lang === "hi") return photo.captionHi;
    if (lang === "ar") return photo.captionAr;
    if (lang === "pt") return photo.captionPt;
    if (lang === "ko") return photo.captionKo;
    if (lang === "zh") return photo.captionZh;
    if (lang === "ru") return photo.captionRu;
    if (lang === "es") return photo.captionEs;
    if (lang === "de") return photo.captionDe;
    if (lang === "fr") return photo.captionFr;
    if (lang === "it") return photo.captionIt;
    if (lang === "en") return photo.captionEn;
    return photo.captionJa;
  };
  const getSub = (photo: typeof photos[0]) => {
    if (lang === "zh-TW") return photo.subZhTW;
    if (lang === "ne") return photo.subNe;
    if (lang === "tl") return photo.subTl;
    if (lang === "id") return photo.subId;
    if (lang === "vi") return photo.subVi;
    if (lang === "th") return photo.subTh;
    if (lang === "hi") return photo.subHi;
    if (lang === "ar") return photo.subAr;
    if (lang === "pt") return photo.subPt;
    if (lang === "ko") return photo.subKo;
    if (lang === "zh") return photo.subZh;
    if (lang === "ru") return photo.subRu;
    if (lang === "es") return photo.subEs;
    if (lang === "de") return photo.subDe;
    if (lang === "fr") return photo.subFr;
    if (lang === "it") return photo.subIt;
    if (lang === "en") return photo.subEn;
    return photo.subJa;
  };

  useEffect(() => {
    const el = scrollRef.current;
    if (!el) return;
    const handleScroll = () => {
      const step = CARD_WIDTH + GAP;
      const idx = Math.round(el.scrollLeft / step);
      setActiveIndex(Math.min(idx, photos.length - 1));
    };
    el.addEventListener("scroll", handleScroll, { passive: true });
    return () => el.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollTo = (idx: number) => {
    const el = scrollRef.current;
    if (!el) return;
    el.scrollTo({ left: (CARD_WIDTH + GAP) * idx, behavior: "smooth" });
    setActiveIndex(idx);
  };

  const onMouseDown = (e: React.MouseEvent) => {
    setIsDragging(true);
    setStartX(e.pageX);
    setScrollLeftStart(scrollRef.current?.scrollLeft ?? 0);
  };
  const onMouseMove = (e: React.MouseEvent) => {
    if (!isDragging || !scrollRef.current) return;
    e.preventDefault();
    scrollRef.current.scrollLeft = scrollLeftStart - (e.pageX - startX);
  };
  const onMouseUp = () => setIsDragging(false);

  return (
    <section id="gallery" className="py-16 sm:py-24 bg-[#e8f9f8] overflow-hidden">
      <div
        ref={headerRef as React.RefObject<HTMLDivElement>}
        className={`max-w-7xl mx-auto px-4 sm:px-6 mb-8 sm:mb-12 transition-all duration-700 ease-out ${headerVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}
      >
        <p className="text-xs text-[#0ABAB5] tracking-widest font-bold mb-3">IKEI ISLAND, OKINAWA</p>
        <div className="flex items-end justify-between flex-wrap gap-4">
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-gray-800 leading-tight" style={{ fontFamily: "'Noto Serif JP', serif" }}>
            {t("gallery_heading")}
          </h2>
          <p className="text-gray-400 text-sm leading-relaxed max-w-sm hidden sm:block">
            {t("gallery_sub")}
          </p>
        </div>
        <p className="text-gray-400 text-xs leading-relaxed mt-2 sm:hidden">
          {t("gallery_sub")}
        </p>
      </div>

      <div
        ref={scrollRef}
        className={`flex overflow-x-auto scrollbar-hide cursor-grab active:cursor-grabbing select-none transition-opacity duration-700 ${headerVisible ? "opacity-100" : "opacity-0"}`}
        style={{
          gap: `${GAP}px`,
          paddingLeft: "16px",
          paddingRight: "16px",
          scrollSnapType: "x mandatory",
          WebkitOverflowScrolling: "touch",
        }}
        onMouseDown={onMouseDown}
        onMouseMove={onMouseMove}
        onMouseUp={onMouseUp}
        onMouseLeave={onMouseUp}
      >
        {photos.map((photo, i) => (
          <div
            key={i}
            className="flex-shrink-0 relative rounded-2xl overflow-hidden group"
            style={{
              width: `${CARD_WIDTH}px`,
              height: `${CARD_HEIGHT}px`,
              scrollSnapAlign: "start",
            }}
          >
            <img
              src={photo.src}
              alt={getCaption(photo)}
              className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
              draggable={false}
              loading="lazy"
              decoding="async"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/10 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
            <div className="absolute bottom-0 left-0 right-0 p-5 translate-y-2 group-hover:translate-y-0 opacity-0 group-hover:opacity-100 transition-all duration-300">
              <p className="text-white font-bold text-sm" style={{ fontFamily: "'Noto Serif JP', serif" }}>
                {getCaption(photo)}
              </p>
              <p className="text-white/70 text-xs mt-1">{getSub(photo)}</p>
            </div>
            <div className="absolute top-3 left-3 w-6 h-6 flex items-center justify-center rounded-full bg-black/30 text-white text-xs font-bold opacity-0 group-hover:opacity-100 transition-opacity duration-300">
              {i + 1}
            </div>
          </div>
        ))}
        <div className="flex-shrink-0 w-4" />
      </div>

      <div className="flex items-center justify-center gap-2 mt-8 flex-wrap px-6">
        {photos.map((_, i) => (
          <button
            key={i}
            onClick={() => scrollTo(i)}
            className={`rounded-full transition-all duration-300 cursor-pointer ${
              i === activeIndex
                ? "w-6 h-2 bg-[#0ABAB5]"
                : "w-2 h-2 bg-gray-300 hover:bg-[#0ABAB5]/50"
            }`}
          />
        ))}
      </div>

      <p className="text-center text-gray-300 text-xs mt-4 tracking-widest">&larr; DRAG TO EXPLORE &rarr;</p>
    </section>
  );
}
